import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../__base';

export const userApiSliceV3 = createApi({
  reducerPath: 'userApiSliceV3',
  baseQuery: baseQuery('v3'),
  tagTypes: ['User', 'CurrentUser'],
  endpoints: (build) => ({
    getCurrentUser: build.query({
      query: () => ({
        url: '/users/current',
        method: 'GET',
      }),
      providesTags: ['CurrentUser'],
      extraOptions: {
        maxRetries: 3,
      },
    }),
    getUserAttributes: build.query({
      query: (userId) => ({
        url: `/users/${userId}/attributes`,
        method: 'GET',
      }),
      providesTags: ['UserAttributes'],
    }),
    resendVerificationEmail: build.query({
      query: (userId) => ({
        url: `/users/${userId}/resend-verification-emails`,
      }),
    }),
    updateCurrentUser: build.mutation({
      query: ({ userId, payload }) => ({
        url: `/users/${userId}`,
        method: 'PATCH',
        body: JSON.stringify(payload),
        headers: {
          'Content-type': 'application/vnd.api+json',
        },
      }),
    }),
    appEvents: build.mutation({
      query: ({ payload }) => ({
        url: '/app/events',
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-type': 'application/vnd.api+json',
        },
      }),
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useResendVerificationEmailQuery,
  useGetUserAttributesQuery,
  useUpdateCurrentUserMutation,
  useAppEventsMutation,
} = userApiSliceV3;
